import apiUrls from 'apis/apiUrls';
import { axiosInstance } from 'helper/axiosHelper';

const reportsService = {
  getAllReports: ({ page, ...params }: any) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getAllReports(),
      config: {
        params: {
          pageNumber: page || 1,
          ...params,
        },
      },
    });
  },

  getFilteredReports: ({ page, ...data }: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.getFilteredReports(),
      config: {
        params: { pageNumber: page || 1 },
      },
      data: {
        name: data.search || '',
        stores: data.stores,
        fitness: data.fitness,
        companyId: data.companyId,
      },
    });
  },

  downloadReport: (params: { companyId: string }) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.downloadReport(),
      config: { params, responseType: 'blob' },
    });
  },

  downloadCandidatesReports: ({ companyId, candidateIds }: { companyId: string; candidateIds: number[] }) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.downloadCandidatesReports(),
      config: {
        params: {
          companyId, candidates: candidateIds.join(','),
        }, responseType: 'blob',
      },
    });
  },

  downloadFilteredReports: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.downloadFilteredReports(),
      config: { responseType: 'blob' },
      data: {
        companyId: data.companyId,
        name: data.search || '',
        stores: data.stores,
        fitness: data.fitness,
      },
    });
  },
};

export default reportsService;
